export enum TodoStateEnum {
  Done = 'Done',
  Pending = 'Pending',
  Rejected = 'Rejected'
}
